import { ArrowLeft, X } from 'lucide-react';
import { MarketingPanel } from './MarketingPanel';

interface MarketingPanelPageProps {
  onClose?: () => void;
}

export function MarketingPanelPage({ onClose }: MarketingPanelPageProps) {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header with back button */}
      <div className="bg-white border-b border-gray-200 sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            {onClose && (
              <button
                onClick={onClose}
                className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
                aria-label="Back"
              >
                <ArrowLeft className="w-6 h-6 text-gray-700" />
              </button>
            )}
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Marketing Panel</h1>
              <p className="text-sm text-gray-600">Manage coupons and track earnings</p>
            </div>
          </div>
          {onClose && (
            <button
              onClick={onClose}
              className="p-2 hover:bg-gray-100 rounded-lg transition-colors md:hidden"
              aria-label="Close"
            >
              <X className="w-6 h-6 text-gray-700" />
            </button>
          )}
        </div>
      </div>

      {/* Marketing Panel Content */}
      <MarketingPanel />
    </div>
  );
}
